import useStore from './useStore';

const useShowStore = () => {
    const { showStore } = useStore();

    return showStore;
};

export default useShowStore;
